import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
} from '@angular/material/snack-bar';

import { TranslateModule } from '@ngx-translate/core';

import { IconSpriteModule } from '@personal-area/icon-sprite';

export interface SuccessSnackBarConfig {
  text: string;
  textParams?: Record<string, string>;
}

@Component({
  standalone: true,
  imports: [TranslateModule, MatSnackBarModule, IconSpriteModule],
  template: `
    <svg-icon-sprite
      [src]="'./assets/img/icons/sprite.svg#check'"
    ></svg-icon-sprite>
    <span
      [translate]="_data.text"
      [translateParams]="_data.textParams"
      matSnackBarLabel
    ></span>
  `,
  styleUrls: ['success-snack-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessSnackBarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) protected _data: SuccessSnackBarConfig,
  ) {}
}
